module.exports = __webpack_public_path__ + "img/a111@2x.744edcd2.png";